import React from "react";
import MaskedInput from "react-text-mask";
import DatePicker from "react-datepicker";
import Select, { components } from "react-select-v2";
// component
import { maskDate } from "helper/dateFormat";
import { HintField, LabelField } from "components";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { convertUTCToLocalDate } from "components/UTC/UtcConverter";
import { getDateFormat, getDateFormatForDatePicket } from "helper/dateFormat";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";

const selectControlStyles = {
  backgroundColor: "#F3F6F9",
  borderColor: "#F3F6F9",
  color: "#3F4254",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
  height: "48px",
};

const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
  }),
};
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};
const formatOptionLabel = ({ label, account_id }) => {
  return (
    <div className="dropdown-container" key={account_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};

const getInstallmentOptions = () => {
  let installmentOptions = [];
  for (let i = 2; i <= 24; i++) {
    installmentOptions.push({
      value: i,
      label: `${i} monthly installments`,
    });
  }
  return installmentOptions;
};

const AddInstallmentsPayment = ({
  formik,
  formikKey = "installmentDetails",
  onInstallmentChange,
  onDateChange,
  installmentValue,
  dateValue,
  manageFromOutside = false,
  installmentFieldLabel = "Installments",
  dateFieldLabel = "Last installment date",
  dateRequired = false,
  disabled = false,
  lastInstallment,
  numberInstallment,
}) => {
  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();

  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(
    dateFormate || "mm/dd/yyyy"
  );

  const installOptions = getInstallmentOptions();

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }

  const getCurrentInstallment = (value) => {
    const findInstallment = installOptions.find((item) => item.value === value);
    return findInstallment || "";
  };

  return (
    <div className="row my-5 add-installment-payment">
      <div className="col-12 col-md-6">
        <LabelField title={installmentFieldLabel} mandatory={true} />
        <Select
          {...{
            formik,
            name: `${formikKey}.cycle`,
            checkValidation: false,
          }}
          classNamePrefix="react-select"
          formatOptionLabel={formatOptionLabel}
          options={installOptions}
          styles={colourStyles}
          onChange={(value) => {
            if (onInstallmentChange) return onInstallmentChange(value);
            if (!value) {
              formik.setFieldValue(`${formikKey}.cycle`, "");
              return;
            }
            formik.setFieldValue(`${formikKey}.cycle`, value?.value);
          }}
          value={
            manageFromOutside
              ? getCurrentInstallment(installmentValue)
              : formik.values?.[formikKey]?.cycle
              ? getCurrentInstallment(formik.values?.[formikKey]?.cycle)
              : ""
          }
          isClearable={true}
          components={{ DropdownIndicator }}
          isDisabled={disabled}
        />
        {numberInstallment?.touched && numberInstallment?.error ? (
          <HintField error={numberInstallment?.error} />
        ) : null}
      </div>
      <div className="col-12 col-md-6">
        <LabelField title={dateFieldLabel} mandatory={dateRequired} />
        <DatePicker
          isClearable
          showIcon
          placeholderText={placeholderFormat}
          dateFormat={dateFormate}
          selected={
            manageFromOutside
              ? dateValue
              : formik?.values?.[formikKey]?.startInstallment &&
                convertUTCToLocalDate(
                  formik?.values?.[formikKey]?.startInstallment
                )
          }
          minDate={new Date()}
          onChange={(e) => {
            if (onDateChange) return onDateChange(e);
            formik.setFieldValue(`${formikKey}.startInstallment`, e);
            convertLocalToUTCDate(e, `${formikKey}.startInstallment`);
          }}
          customInput={
            <MaskedInput
              pipe={autoCorrectedDatePipe}
              mask={dateMask}
              keepCharPositions={true}
              guide={true}
            />
          }
          disabled={disabled}
        />
        {lastInstallment?.touched && lastInstallment?.error ? (
          <HintField error={lastInstallment?.error} />
        ) : null}
      </div>
    </div>
  );
};

export default AddInstallmentsPayment;
